// Aurum & Ivy Logo Components - Using actual image files
import React from 'react';

// Main Crest Logo - For website header and branding
export function Logo({ className = "h-16", showText = true }) {
  return (
    <div className="flex flex-col items-center gap-2">
      <LogoCrest className={className} />
      {showText && (
        <div className="text-center">
          <h1
            className="font-headline text-xl md:text-2xl font-bold tracking-wider"
            style={{
              background: 'linear-gradient(135deg, #C9A962 0%, #E5D4A1 50%, #C9A962 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}
          >
            AURUM & IVY
          </h1>
          <p
            className="text-xs md:text-sm tracking-[0.3em] uppercase mt-1"
            style={{ color: '#C9A962' }}
          >
            Artisan Events
          </p>
        </div>
      )}
    </div>
  );
}

// Crest Logo - Uses actual image file
export function LogoCrest({ className = "h-16 w-auto" }) {
  return (
    <img
      src="/crest_main_logo.png"
      alt="Aurum & Ivy Crest"
      className={className}
      style={{ objectFit: 'contain' }}
    />
  );
}

// Simple Swirl Logo - For products/items placeholder
export function LogoSimple({ className = "h-12 w-auto" }) {
  return (
    <img
      src="/gift_item_logo.png"
      alt="Aurum & Ivy"
      className={className}
      style={{ objectFit: 'contain' }}
    />
  );
}

// Product Placeholder - Uses the swirl logo with background
export function ProductPlaceholder({ className = "w-full h-full" }) {
  return (
    <div className={`${className} flex items-center justify-center bg-gradient-to-br from-muted/50 via-background to-muted/30`}>
      <LogoSimple className="h-24 w-auto opacity-60" />
    </div>
  );
}

// Header Logo - Horizontal layout for navigation
export function LogoHeader({ className = "", showTagline = true }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <LogoCrest className="h-10 w-auto" />
      <div className="flex flex-col">
        <span
          className="font-headline text-lg font-bold tracking-wider"
          style={{
            background: 'linear-gradient(135deg, #C9A962 0%, #E5D4A1 50%, #C9A962 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }}
        >
          AURUM & IVY
        </span>
        {showTagline && (
          <span className="text-[10px] tracking-[0.25em] uppercase text-muted-foreground">
            Artisan Events
          </span>
        )}
      </div>
    </div>
  );
}

// Compact Sidebar Logo
export function LogoSidebar({ className = "", onClick }) {
  return (
    <div
      className={`flex items-center gap-3 cursor-pointer ${className}`}
      onClick={onClick}
    >
      <LogoCrest className="h-12 w-auto" />
      <div className="flex flex-col">
        <span
          className="font-headline text-lg font-bold tracking-wider"
          style={{
            background: 'linear-gradient(135deg, #C9A962 0%, #E5D4A1 50%, #C9A962 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }}
        >
          Aurum & Ivy
        </span>
        <span className="text-[10px] tracking-[0.2em] uppercase text-muted-foreground">
          Artisan Events
        </span>
      </div>
    </div>
  );
}

// Export default
export default Logo;
